import { Link, useLocation } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaPhoneAlt, FaYoutube, FaTwitter } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import logo from '../assets/images/hf-logo.png';
import { content, getLangFromPath } from '../i18n';

function Footer() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const t = content[lang];

  // const homePath = lang === 'en' ? '/en' : '/';
  const contactPath = lang === 'en' ? '/en/contact' : '/contact';

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand-block">
          <img src={logo} alt="Green Your Freight" className="footer-logo" />
          <p className="footer-copy">{t.footer.copy}</p>
        </div>

        <div className="footer-column">
          <h4>{t.footer.contact}</h4>
          <a href="tel:+302100000000" className="footer-line">
            <FaPhoneAlt />
            <span>+30 210 0140 312</span>
          </a>
          <a href="mailto:info@greenyourfreight.eu" className="footer-line">
            <MdEmail />
            <span>info@greenyourfreight.eu</span>
          </a>
        </div>

        <div className="footer-column">
          <h4>{t.footer.usefulLinks}</h4>
          <a href="https://greenyourfreight.eu" target="_blank" rel="noreferrer">
            {t.footer.officialSite}
          </a>
          <a href="https://app.greenyourfreight.eu" target="_blank" rel="noreferrer">
            {t.footer.openApp}
          </a>
          <Link to={contactPath}>{t.footer.support}</Link>
        </div>

        <div className="footer-column">
          <h4>{t.footer.businessInfo}</h4>
          <div className="footer-business-line">
            <strong>{t.footer.vat}:</strong> <span>802924821</span>
          </div>
          <div className="footer-business-line">
            <strong>{t.footer.gemi}:</strong> <span>185451701000</span>
          </div>
          <div className="footer-business-line">
            <strong>{t.footer.address}:</strong> 
            <span>	
              {t.footer.actualAddress}
            </span>
          </div>
        </div>

        <div className="footer-column">
          <h4>{t.footer.followUs}</h4>
          <div className="socials">
            <a href="https://www.facebook.com/profile.php?id=61553672166383" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://x.com/GYF_project" target="_blank" rel="noreferrer" aria-label="Instagram">
              <FaTwitter />
            </a>
            <a href="https://www.linkedin.com/company/life-green-your-freight/?viewAsMember=true" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="https://www.youtube.com/@LIFEGreenYourFreight" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaYoutube/>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>{t.footer.copyright}</span>
          <span>{t.footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;